module.exports = __webpack_public_path__ + "0af5d249/img/placeholder.888fcd0b.svg";